module.exports = __webpack_public_path__ + "static/media/Fortress.2557356f.svg";